module.exports = "fragment ColorFragment on Color {\n  red\n  green\n  blue\n}\n"